/* TT-REVIEWS - every review and the Questions, from Judge.me's public widget feed.

   Josh, 2026-10-15 (#2 on the launch list): the new theme showed five reviews
   and no Questions. Judge.me embeds only the first page in a metafield; the
   rest is behind the same two endpoints its own widget calls from the
   shopper's browser, unauthenticated and CORS-open:

     api.judge.me/reviews/reviews_for_widget     (paged, 5 at a time)
     cdn.judge.me/api/questions/questions_for_widget

   Both answer with Judge.me's widget HTML. It is PARSED here, never inserted:
   each review is redrawn in snippets/tt-pdp-reviews.liquid's own markup with
   textContent, so none of Judge.me's markup, CSS or JS reaches the page and a
   review body can never inject anything.

   No script, no change: the block is the first five, as it was. */
(function () {
  'use strict';

  var PER = 5;

  function el(tag, style, text) {
    var e = document.createElement(tag);
    if (style) e.setAttribute('style', style);
    if (text != null) e.textContent = text;
    return e;
  }

  function stars(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += i <= n ? '★' : '☆';
    return s;
  }

  function parse(html) {
    return new DOMParser().parseFromString(html || '', 'text/html');
  }

  function txt(node, sel) {
    var n = node.querySelector(sel);
    return n ? n.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* The body keeps its paragraph breaks: Judge.me writes one <p> per
     paragraph, and flattening them would run two thoughts together. */
  function bodyText(node, sel) {
    var n = node.querySelector(sel);
    if (!n) return '';
    var ps = n.querySelectorAll('p');
    if (!ps.length) return n.textContent.trim();
    return Array.prototype.map.call(ps, function (p) { return p.textContent.trim(); })
      .filter(Boolean).join('\n\n');
  }

  function initReviews(box) {
    var more = box.querySelector('[data-tt-jm-more]');
    var count = box.querySelector('[data-tt-jm-count]');
    var list = box.parentNode.querySelector('[data-tt-jm-list]');
    if (!more || !list) return;
    var c = box.dataset;
    var have = Number(c.have) || 0;
    var shown = Number(c.shown) || 0;
    var page = 2;
    var loading = false;

    var stStars = 'font-size: 13px; letter-spacing: 0.12em; color: ' + c.amber + ';';
    var stMeta = 'font-size: 12px; letter-spacing: 0.06em; text-transform: uppercase; color: var(--z-muted);';
    var stTitle = 'font-family: var(--z-font-display); font-weight: 700; font-size: 17px; letter-spacing: -0.01em; margin-bottom: 8px;';
    var stBody = 'margin: 0; font-size: 15px; color: ' + c.bodyInk + '; line-height: 1.75; white-space: pre-line;';

    function draw(rev) {
      var row = el('div', 'border-top: 1px solid ' + c.hair + '; padding: 22px 0;');
      row.className = 'tt-review';
      var head = el('div', 'display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 8px; gap: 16px;');
      var score = Number((rev.querySelector('[data-score]') || {}).getAttribute ? rev.querySelector('[data-score]').getAttribute('data-score') : 5) || 5;
      head.appendChild(el('span', stStars, stars(score)));
      var who = txt(rev, '.jdgm-rev__author');
      var where = txt(rev, '.jdgm-rev__location').replace(/^\(|\)$/g, '');
      head.appendChild(el('span', stMeta, who + (where ? ' — ' + where : '')));
      row.appendChild(head);
      var title = txt(rev, '.jdgm-rev__title');
      if (title) row.appendChild(el('div', stTitle, title));
      var body = bodyText(rev, '.jdgm-rev__body');
      if (body) row.appendChild(el('p', stBody, body));
      /* Photographs open full size in a new tab. Thumbnails ask Judge.me for
         200px, as the server-rendered rows do. */
      var pics = rev.querySelectorAll('.jdgm-rev__pics a[href]');
      if (pics.length) {
        var strip = el('div', 'display: flex; flex-wrap: wrap; gap: 8px; margin-top: 14px;');
        Array.prototype.forEach.call(pics, function (a) {
          var href = a.getAttribute('href');
          if (!/^https:\/\//.test(href)) return;
          var link = el('a', 'display: block; line-height: 0; cursor: zoom-in;');
          link.href = href; link.target = '_blank'; link.rel = 'noopener';
          link.setAttribute('aria-label', 'Open customer photo from ' + (who || 'this') + "'s review");
          var img = el('img', 'width: 68px; height: 68px; object-fit: cover; display: block; background: var(--z-hairline);');
          img.src = href.replace('width=1024', 'width=200'); img.alt = ''; img.loading = 'lazy';
          link.appendChild(img); strip.appendChild(link);
        });
        if (strip.children.length) row.appendChild(strip);
      }
      return row;
    }

    function load() {
      if (loading) return;
      loading = true;
      more.disabled = true;
      more.textContent = 'Loading…';
      var url = 'https://api.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(c.shop) +
        '&shop_domain=' + encodeURIComponent(c.shop) + '&platform=shopify&per_page=' + PER +
        '&page=' + page + '&product_id=' + encodeURIComponent(c.product);
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        var revs = parse(d.html).querySelectorAll('.jdgm-rev');
        Array.prototype.forEach.call(revs, function (rev) { list.appendChild(draw(rev)); });
        shown += revs.length;
        page += 1;
        if (count) count.textContent = 'Showing ' + Math.min(shown, have) + ' of ' + have + ' reviews.';
        loading = false;
        more.disabled = false;
        more.textContent = 'Show more reviews →';
        if (!revs.length || shown >= have) {
          more.remove();
          if (count) count.remove();
        }
      }).catch(function () {
        loading = false;
        more.disabled = false;
        more.textContent = 'Show more reviews →';
      });
    }

    more.hidden = false;
    more.addEventListener('click', load);
  }

  function initQuestions(box) {
    var list = box.querySelector('[data-tt-jm-qlist]');
    var head = box.querySelector('[data-tt-jm-qhead]');
    var c = box.dataset;
    if (!list || !c.product) return;
    var url = 'https://cdn.judge.me/api/questions/questions_for_widget?product_id=' + encodeURIComponent(c.product) +
      '&shop_domain=' + encodeURIComponent(c.shop) + '&platform=shopify';
    fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var qs = parse(d.html).querySelectorAll('.jdgm-quest');
      if (!qs.length) return;
      Array.prototype.forEach.call(qs, function (q, i) {
        var row = el('div', 'border-top: ' + (i === 0 ? '2px solid var(--z-ink)' : '1px solid var(--z-hairline)') + '; padding: 22px 0;');
        row.appendChild(el('div', 'font-size: 12px; letter-spacing: 0.06em; text-transform: uppercase; color: var(--z-muted); margin-bottom: 8px;', txt(q, '.jdgm-quest__asker .jdgm-rev__author') || 'A customer'));
        row.appendChild(el('p', 'margin: 0; font-family: var(--z-font-display); font-weight: 700; font-size: 17px; letter-spacing: -0.01em; line-height: 1.4;', bodyText(q, '.jdgm-quest__body')));
        Array.prototype.forEach.call(q.querySelectorAll('.jdgm-ans'), function (a) {
          var ans = el('div', 'margin-top: 12px; padding-left: 16px; border-left: 2px solid var(--z-amber);');
          ans.appendChild(el('div', 'font-size: 12px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: var(--z-muted); margin-bottom: 6px;', (txt(a, '.jdgm-ans__answerer .jdgm-rev__author') || 'Zola Mod') + ' replied'));
          ans.appendChild(el('p', 'margin: 0; font-size: 15px; line-height: 1.75; white-space: pre-line;', bodyText(a, '.jdgm-rev__body')));
          row.appendChild(ans);
        });
        list.appendChild(row);
      });
      if (head) head.textContent = 'Questions (' + qs.length + ')';
      box.hidden = false;
    }).catch(function () {});
  }

  /* WRITE A REVIEW / ASK A QUESTION open Judge.me's own forms (Josh,
     2026-10-16). Its widget sits hidden in #tt-jm-forms; the review button
     presses Judge.me's write link (which opens Judge.me's pop-up even while the
     widget is hidden), the question button reveals just Judge.me's question
     form under our buttons. A synthetic MouseEvent, not .click(): Judge.me's
     delegated handler ignores the bare call. If Judge.me never set the widget
     up, the buttons fall back to the contact page rather than doing nothing. */
  function press(el) {
    el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  }
  function initForms(btn) {
    btn.addEventListener('click', function (e) {
      var box = document.getElementById('tt-jm-forms');
      var w = box && box.querySelector('.jdgm-widget');
      var mode = btn.getAttribute('data-tt-jm-open');
      var target = w && w.querySelector(mode === 'review' ? '.jdgm-write-rev-link' : '.jdgm-ask-question-btn');
      if (!target) {
        if (btn.getAttribute('data-fallback')) window.location.href = btn.getAttribute('data-fallback');
        e.preventDefault();
        return;
      }
      e.preventDefault();
      if (mode === 'review') {
        box.hidden = true;
        press(target);
        return;
      }
      var open = box.hidden;
      box.hidden = !open;
      press(target);
      if (open) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function boot() {
    document.querySelectorAll('[data-tt-jm-open]').forEach(initForms);
    document.querySelectorAll('[data-tt-jm]').forEach(initReviews);
    document.querySelectorAll('[data-tt-jm-questions]').forEach(initQuestions);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
